module.exports = __webpack_public_path__ + "static/img/1.5cb0821.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/1.png
// module id = Yagw
// module chunks = 0